import { useState } from 'react';

export const BANK_STEPS = { closed: 0, send: 1, confirm: 2 };

// The reminder means "you have our details but you have not told us what you sent": it is armed
// once the customer takes something away from step 1 and cleared by the submission it asks for.
const useBankTransferFlow = () => {
  const [step, setStep] = useState(BANK_STEPS.closed);
  const [isTransferStarted, setIsTransferStarted] = useState(false);
  const [isReminderArmed, setIsReminderArmed] = useState(false);
  const [isReminderDismissed, setIsReminderDismissed] = useState(false);
  const [submittedAmountMinor, setSubmittedAmountMinor] = useState(null);
  const [isSubmittedBannerDismissed, setIsSubmittedBannerDismissed] = useState(false);

  const armReminder = () => {
    setIsReminderArmed(true);
    setIsReminderDismissed(false);
  };

  return {
    step,
    openSend: () => setStep(BANK_STEPS.send),
    goToConfirm: () => {
      setIsTransferStarted(true);
      setStep(BANK_STEPS.confirm);
    },
    goBack: () => setStep(BANK_STEPS.send),
    close: () => {
      setStep(BANK_STEPS.closed);
      if (isTransferStarted) {
        armReminder();
      }
    },
    // Copying a detail means the transfer happens outside the portal, so a confirmation is owed
    // even if the customer never reaches step 2.
    onCopyBankDetail: armReminder,
    onSubmitted: declaredAmountMinor => {
      setIsTransferStarted(false);
      setIsReminderArmed(false);
      setSubmittedAmountMinor(declaredAmountMinor ?? null);
      setIsSubmittedBannerDismissed(false);
    },
    isReminderVisible: isReminderArmed && !isReminderDismissed && step === BANK_STEPS.closed,
    confirmFromReminder: () => {
      setIsTransferStarted(true);
      setStep(BANK_STEPS.confirm);
    },
    dismissReminder: () => setIsReminderDismissed(true),
    isSubmittedBannerVisible: submittedAmountMinor !== null && !isSubmittedBannerDismissed,
    submittedAmountMinor,
    dismissSubmittedBanner: () => setIsSubmittedBannerDismissed(true),
  };
};

export default useBankTransferFlow;
